var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8954_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2494 3.30949C-0.436389 7.03534 -0.416358 13.0648 3.30949 16.7506C7.03534 20.4364 13.0648 20.4164 16.7506 16.6905C20.4364 12.9647 20.4164 6.93519 16.6905 3.2494C12.9647 -0.436389 6.93519 -0.416358 3.2494 3.30949ZM14.6273 8.17714L9.45915 13.4053C9.01846 13.846 8.29733 13.846 7.85663 13.4053L7.65632 13.205L7.05538 12.6041L5.37273 10.9415C4.93204 10.5008 4.93204 9.77965 5.37273 9.33896C5.81343 8.89827 6.53456 8.89827 6.97525 9.33896L8.65789 11.0016L13.0248 6.59465C13.4654 6.15396 14.1866 6.15396 14.6273 6.59465C15.068 7.01531 15.068 7.73644 14.6273 8.17714Z",
    fill: "#65CDBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8954_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ea9d36be40cc17c1a7574d3ea522686b.svg";
export { ForwardRef as ReactComponent };